export default __webpack_public_path__ + "static/media/Under.b1e4e47c.jpeg";